import * as angular from 'angular';
import { fn } from '@common/utils';
import resolveToError = fn.resolveToError;
import UISafe = fn.UISafe;
import FindFirst = fn.FindFirst;
import ToDictionary = fn.ToDictionary;
import { DialogService } from '@services/dialogservice';
import { NavSettingsService, InfUserSettingsAccess } from '@common/services/settingsservice';

import * as kutils from '@common/navkendo/kutils';
import { constants as kconstants, template as ktemplate } from '@common/navkendo/kutils';
import { NavClientService, INavPageClientInfo, IPageQueryResult } from '@common/navdata';
import { NavPropertyValue } from '@common/navdata';
import { SearchInputs } from '../searchinput/searchinputs';
import { IInfNotification, NavKendoRegister, CreateDropDownOverlay } from '@common/navkendo';
import { GetGridSettings } from '@common/navkendo/navgrid';
import { NavGridVisibility, NumericType, TNavUrlAccess, IPageQueryConstraint, IPageProperty, ILookupInfo } from '@common/navdata';
import { IDimension } from '../../commoncontrols/commoncontrols';
import { CompatibilityService } from '@services/compatibilityservice';
import { $ModalClose } from '@common/services/DialogService';
;
/** Event being broadcasted on Row Selection (e : IAngularEvent, item : selected dataitem) */
export var $NavLookupCtrl_Selected = "NavLookupCtrl:Selected";

/** Nav Item Lookup Page Display Controller [broadcasts '"NavLookupCtrl:Selected"' on Item got selected] */
export var NavReadMultipleSelectCtrl = ["$scope", "NavSettings", "TargetPageClient", "NavClient", "DialogService",
    "UserSettings", "QueryConstraints", "InitialDisplayFields", "InitialSearchFields", "DetailConfig", "InitialData",
    function NavLookupCtrl($scope: ng.IScope,
        NavSettings: NavSettingsService,
        TargetPageClient: INavPageClientInfo,
        NavClient: NavClientService,
        DialogService: DialogService,
        /** the Settings Persistence Object to Store/Load Values from */
        UserSettings: InfUserSettingsAccess,
        /** Optional External Query Constraints */
        QueryConstraints?: IPageQueryConstraint[],
        /** Optional explicit Initial Display Fields (only useful for first time a user opens)  */
        InitialDisplayFields?: string[],
        /** Optional Initial Search Fields */
        InitialSearchFields?: Array<string | IPageQueryConstraint>,
        DetailConfig?: IGridDetailConfig,
        /** Optionaly Initially shown result */
        InitialData?: IPageQueryResult<any> | PromiseLike<IPageQueryResult<any>>) {
        /** Access to Search Grid Instance */
        var getKendoSearchGrid = () => <kendo.ui.Grid>$scope["searchResultGrid"];
        $scope["DetailConfig"] = DetailConfig || { template: null, init: null };
        let $c = NavClient.$c,
            metaData = TargetPageClient.MetaData,
            pageName = metaData.PageName,
            navUrl = TargetPageClient.Url,
            /** Exclude from Visual Filters :
            * - bool/enum typed properties which are "prefiltered" */
            excludeFilterNames = (QueryConstraints || []).map(item => metaData.PropsByName[item.FieldName])
                .filter(fn.isSet)
                .filter(item => (item.Type == "Boolean") || !!item.EnumMappings)
                .map(item => item.AliasName),

            searchInputs = $scope["SearchInputs"] = new SearchInputs(),
            getUserConstraints = fn.proxy(searchInputs.GetAsConstraints, searchInputs, metaData),
            initInputs = searchInputs.RefreshAvailableProperties({
                NavClient: NavClient,
                NavUrl: navUrl,
                Pages: pageName,
                Include: TargetPageClient.ValidFilterNames,
                Exclude: excludeFilterNames
            }),
            getNotification = () => <IInfNotification>$scope["readErrors"],
            searchGroup = kendo.guid(),
            clearErrors = () => {
                var notification = getNotification();
                if (notification) {
                    notification.RemoveNotifications("readMultiple");
                }
            };

        /** Current State Information */
        var state = $scope["state"] = {
            /** Marker Search is currently in progress */
            SearchRunning: false,
            /** Max Items to Request */
            MaxQuery: 1000,
        };

        /** Recalculate Size  */
        var refreshSize = $scope["refreshSize"] = fn.debounce(() => {
            var totalDim = <IDimension>$scope["TotalDim"],
                searchInpuDim = <IDimension>$scope["SearchInputDim"],
                buttonDim = <IDimension>$scope["ActionButtonsDim"],
                feedbackDim = <IDimension>$scope["FeedbackDim"],
                grid = getKendoSearchGrid();

            if (totalDim && searchInpuDim && buttonDim && grid && grid.element) {
                var maxGridHeight = totalDim.height - searchInpuDim.height - buttonDim.height - feedbackDim.height;
                kutils.SetMaxGridHeight(grid, maxGridHeight, 270);
            }
        }, 75);
        var currQuery: PromiseLike<any>;
        /** DataSource to be bound to Grid */
        var datasource = $scope["dataSource"] = new kendo.data.DataSource(
            {
                autoBind: false, pageSize: 20,
                transport: <any><kendo.data.DataSourceTransportWithFunctionOperations>{
                    read: (readParams) => {
                        let addError = (message: string, error?: boolean) => {
                            var notification = getNotification();
                            if (notification) {
                                notification.AddNotification({ message: message, group: "readMultiple", messageType: error ? "error" : "warning" });
                            }
                        },
                            onError = (e, force) => {
                                readParams.error(e);
                                if (force || (startedQuery === currQuery))
                                    addError(resolveToError(e), true);
                            };
                        try {
                            var filter = readParams.data.filter;
                            var constraints = ((filter && filter.filters) || []).map((item: kendo.data.DataSourceFilterItem) =>
                                <IPageQueryConstraint>{ FieldName: item.field, Value: item.value });
                            constraints.push(...getUserConstraints());
                            constraints.push(...QueryConstraints || []);

                            var startedQuery = currQuery = NavClient.ReadMultiple({
                                PageCount: state.MaxQuery + 1,
                                PageName: pageName,
                                Constraints: constraints,
                                BookmarkData: undefined
                            }, navUrl)
                                .then((data) => {
                                    var items = data.Data;
                                    var overflow = items && items.length == state.MaxQuery + 1;
                                    if (overflow) {
                                        items.splice(items.length - 1, 1);
                                        if (startedQuery == currQuery)
                                            addError("Bitte schränken Sie Ihre Anfrage ein! Es werden maximal " + state.MaxQuery + " Datensätze angezeigt.");
                                    }
                                    readParams.success(data.Data);
                                }).then(undefined, e => onError(e, false));
                        } catch (e) { onError(e, true); }
                    }
                }
            });

        /** Trigger Start Search */
        var currsearch: JQueryPromise<any> = null;
        var startExecuteSearch = $scope["StartExecuteSearch"] = () => {
            UISafe(() => { // UISafe : Display Errors during search
                clearErrors();
                datasource.data([]);
                state.SearchRunning = true;
                var startedSearch = currsearch = datasource.fetch(refreshSize);
                currsearch.always(() => {
                    if (currsearch == startedSearch) {
                        state.SearchRunning = false;
                        datasource.page(0); // fix invalid page pos on fewer results (kendo bug!?)
                    }
                });
            });
        };
        /** Setup Row Selection Event : Broadcast "Selection" (e = null: close wOut Context) */
        var OnRowSelected = $scope["OnRowSelected"] = (eventOrItem: any) => {
            var dataItem = (eventOrItem instanceof kendo.data.ObservableObject) ? eventOrItem : (eventOrItem && kutils.GetRowItem(eventOrItem));
            $scope.$broadcast($NavLookupCtrl_Selected, dataItem);
        };
        /** Setup Columns Retrieval Function */
        $scope["getColumns"] = () => {
            var result = metaData.Properties
                .filter(item => !item.Invisible && item.GridVisibility != NavGridVisibility.ForcedRemove)
                .map(item => metaData.GetColumn(item));

            if (InitialDisplayFields && InitialDisplayFields.length > 0) {
                result.forEach(item => item.hidden = InitialDisplayFields.indexOf(item.field) < 0);
            }
            result.unshift({
                filterable: false,
                width: kutils.IsKendoMobile() ? "54px" : "51px",
                command: [
                    kutils.GetCommandItem({
                        name: "selectLookupItem",
                        title: "Auswählen",
                        iconClass: "idms_Icon_OK idms_Icon idms_HoverIcon",
                        action: OnRowSelected
                    })]
            });
            return result;
        };

        if (UserSettings) {
            UserSettings.Add("SearchInput", () => searchInputs.Settings());
            UserSettings.Add("SearchGrid", () => GetGridSettings(getKendoSearchGrid()));
        }

        //#region UserSettings Setup (wait for grid to correctly apply settings)
        var waitForGrid = $scope.$watch(() => getKendoSearchGrid(), (newValue => {
            if (!newValue)
                return;
            waitForGrid();

            if (UserSettings) {
                // Store User Settings on Destruction of Scope
                let storeSettings = <() => void>fn.once(UserSettings.Save.bind(UserSettings));
                $scope.$on("$destroy", storeSettings);
                $scope.$on("$destroy", () => { currQuery = undefined; });
                $scope.$on($ModalClose, storeSettings);
            }

            // Load user Settings
            const loadSettings = () => {
                var saerchConstraints = (InitialSearchFields || []).map(item => {
                    if (typeof (item) === "string")
                        return <IPageQueryConstraint>{ FieldName: item };
                    else
                        return item;
                });
                searchInputs.SetSearchInputs(saerchConstraints.map(item => <string>item.FieldName));
                datasource["_NoAutoBind"] = true; // hack : no auto Read wanted here (?)
                return $c.finally($c.when(UserSettings && UserSettings.Load()), () => {
                    return $c.when(InitialData).then(initResultData => {
                        if (initResultData && initResultData.Data) {
                            datasource.data(initResultData.Data);
                        } else {
                            // Adjust Explicit Filter Values
                            saerchConstraints.filter(item => item && typeof (item.Value) !== "undefined").forEach(item => {
                                var exInput = searchInputs.GetInput(item.FieldName, true);
                                if (exInput)
                                    exInput.QueryString = item.Value;
                            });

                            // Start Initial Search if stored Constraints
                            var si = getUserConstraints();
                            if (si && (si.length > 0)) {
                                startExecuteSearch();
                            }
                        }
                    });
                });
            };
            initInputs.then(loadSettings, loadSettings);
        }));
        //#endregion
    }];

/** Lookup Window Configuration Options */
export interface IModalReadMultipleSelectConfig {
    /** the Page Client to read data from */
    TargetPage: INavPageClientInfo | string;
    /** Access to NavUrl (if TargetPage is string) */
    NavUrl?: TNavUrlAccess;
    /** Initial Data to Display */
    InitialData?: IPageQueryResult | PromiseLike<IPageQueryResult>;
    /** Optional Additional Query Constraints */
    Constraints?: IPageQueryConstraint[];
    /** User Settings Persitence Token */
    PersistToken?: string;
    /** Title of the Modal Window */
    Title: string;
    /** Optional Inititial Visisble Display Fields */
    InitialDisplayFields?: string[];
    /** Optional Initial Search Input Fields */
    InitialSearchFields?: Array<IPageQueryConstraint | string>;
    /** Optional Grid Detail Config */
    DetailConfig?: IGridDetailConfig;
}

export interface IGridDetailConfig {
    template: string;
    init: (e: kendo.ui.GridDetailInitEvent) => any;
}
/** Show Modal Lookup Page, returns a Promise that will give the selected item or null (null means: Selection was cancelled ) */
export function ShowModalReadMultipleSelect(
    config: IModalReadMultipleSelectConfig,
    $c: CompatibilityService) {
    var modalwindow: kendo.ui.Window;
    var windowOptions = <kendo.ui.WindowOptions>{
        width: "50%",
        position: { top: "200px", left: "20px" },
        resizable: true,
        modal: true,
        actions: ["Undo", "Maximize", "Close"],
    };
    var result = $c.defer<kendo.data.ObservableObject>();
    const DialogService = $c.resolve("DialogService");
    var userSetting = config.PersistToken && $c.resolve("NavSettings").CreateUserSettings(["KWF", "Lookup", "Lookup_" + config.PersistToken]);
    if (userSetting)
        userSetting.Add("ModalWindow", kutils.GetWindowSettings(windowOptions, () => modalwindow));

    var target = config.TargetPage,
        resolveTargetPageClient = typeof target === "string" ? $c.resolve("NavClient").GetPageClientInfo(target, config.NavUrl) : fn.ToFunc(target);
    DialogService.ShowWindow({
        controller: NavReadMultipleSelectCtrl,
        template: require("./NavReadMultipleSelect.fragment.html"),
        windowOptions: $.extend(windowOptions, config.Title && <kendo.ui.WindowOptions>{ title: config.Title }),
        mobile: {
            fullScreen: true
        },
        resolve: {
            /** Target Page Client to Execute Queries by */
            "TargetPageClient": resolveTargetPageClient,
            "UserSettings": fn.ToFunc(userSetting),
            "QueryConstraints": fn.ToFunc(config.Constraints),
            "InitialDisplayFields": fn.ToFunc(config.InitialDisplayFields),
            "InitialSearchFields": fn.ToFunc(config.InitialSearchFields),
            "DetailConfig": fn.ToFunc(config.DetailConfig),
            "InitialData": [() => config.InitialData || undefined]
        }
    }).then(modalState => {
        modalwindow = modalState.window;
        // TODO : More Generic way ?
        if (modalwindow) {
            const undoEl = modalwindow.wrapper.find(".k-window-actions [aria-label='Undo']").attr("title", "Einstellungen zurücksetzen").bind("click.navCustom", function (e) {
                e.preventDefault();
                UISafe(DialogService.ShowConfirm({ message: "Einstellungen zurücksetzen?" }).then(d => d && userSetting.Reset()));
            }).parent().removeAttr("href"); // href : s.times href='#' ...;
            modalState.scope.$on("$destroy", () => undoEl.unbind(".navCustom"));
        }
        modalState.scope.$on($NavLookupCtrl_Selected, (e, item: kendo.data.ObservableObject) => {
            result.resolve(item);
            modalState.closeDialog();
        });

        $c.finally(modalState.close, () => result.resolve(undefined));

    }).then(undefined, err => result.reject(err));

    return result.promise;
}

export interface NavLookupOptions {
    /** Default Max Read for QuickLookup */
    MaxRead: number;
    /** Min Input Length for starting Search */
    MinSearch: number;
    NavProperty: NavPropertyValue;
    AttachedParent?: JQuery; // Custom Lookup Rendering is way easier with angular context, which should be available via attached parent (?)....
    /** for internal Use ... TODO */
    $injector?: ng.auto.IInjectorService;
    $angular?: ng.IScope[];
}

/** Lookup with Button for Detail DrillDown */
export class NavLookupControl extends kendo.ui.Widget {
    // Hack: for change of textbox to button click we don't want to commit
    // but focusout on "result" not triggered, so do it explicitly if not in button
    public options: NavLookupOptions;
    private button: JQuery;
    /** rendered autocomplete Control */
    readonly autoComplete: kendo.ui.AutoComplete;
    private inButton = false;

    autoCompleteState = {
        Open: false,
        Selected: false,
        Focus: false,
        SelectedItem: <any>undefined
    };

    /** Model Available in Header - angular template */
    private headerModel = {
        InfoText: "",
        SearchField: "",
        TargetField: "",
        /** Feld, nach dem das aktuelle, nicht leere Suchergbnis mit der aktuellen Eingabe gefiltert wird */
        MatchField: "",
        // Current 'Raw' Search Value for currently Running Search
        SearchValue: "",
        /** Current Search Result is from history */
        CurrHistory: false,
        /** Current Display Fields */
        Fields: <Array<{
            name: string,
            caption: string,
            id: any,
            /** Current Search Field as Selected From User (might differ from Current 'MatchField' */
            current: boolean,
            /** Marker : Is Technical "Target" = takeover field */
            target: boolean
        }>>[],
        Width: 120,
        Lookup: <ILookupInfo>undefined,

        /** User Explicitly wants no history (Disabled until further discussion) */
        UserNoHistory: true,
        /** History Items (technical keys) */
        History: [],
        /** Current Result is From history */
        IsHistory: true,

    };

    public IsOpen() { return this.autoCompleteState.Open; }
    /** Marker : Underlying Property is Int32 - based */
    private NavIsInt: boolean;

    private readonly applyControlValue: (selectedRow?: any) => PromiseLike<void>;
    constructor(element, options: NavLookupOptions) {
        super(element, resolveOptions(element, options));

        let me = this,
            wrapper = this.element,
            prop = options.NavProperty,
            state = me.autoCompleteState,
            button = this.button = this._initButton(),
            navIsInt = me.NavIsInt = prop && prop.Property.Type == "Int32",
            navIsDecimal = prop && prop.Property.Type == "Decimal",
            autoComplete = this.autoComplete = this._initAutoComplete(),
            // SetUp special Conversion for int based lookups (display "0" as "");
            getFixedVisualValue = navIsInt || navIsDecimal ? (v => v == 0 || v == "0,00" ? "" : v) : fn.identity,
            lastStarted: PromiseLike<any>,
            applyValueToControl = () => {
                // reset opt running current "reverse" apply cycle
                currApplyPromise = undefined;
                return autoComplete.value(currApply = getFixedVisualValue(prop.GetValue(true)));
            },
            currApply: any, // remember currSetValue to avoid recursion
            resetCurr = () => currApply = undefined,
            currApplyPromise: PromiseLike<any>,
            currApplyValue: any, // avoid duplicate calls (reentrancy)
            applyControlValue = this.applyControlValue = async (selectedRow?: any) => {
                if (currApplyPromise != null && currApplyValue === selectedRow)
                    return;
                var toSet = getFixedVisualValue(autoComplete.value());
                if (toSet == currApply)
                    return;
                if (toSet == prop.GetValue() && !selectedRow)
                    return;
                currApplyValue = selectedRow;
                const resetCurr = () => { currApplyPromise = currApplyValue = undefined; };
                // util to propagate err
                const pErr = <T, TResult>(f: ((t: T) => TResult | PromiseLike<TResult>)) => async (err) => { var result = await f(err); if (true) { throw err; }; return result; };
                const pFinally = <T, TResult>(p: PromiseLike<T>, f: ((t: T) => TResult | PromiseLike<TResult>)) => p.then(f, pErr(f));
                const contextEnsured = () => {
                    var getTargetField = () => this.currentLookupInfo && this.currentLookupInfo.LookupInfo.TargetField;
                    let currInfo = this.currentLookupInfo && this.currentLookupInfo.LookupInfo,
                        hasCustomSet = currInfo && !!currInfo.CustomSetMethod,
                        forceValueSet = false; // force Single Value Set in custom set method Scenario (do not use first hit then ...)

                    // Check if Validation of input Value is needed
                    if (!!toSet && getTargetField() && me.lastLookupData) {
                        var loadedMatch = selectedRow;
                        if (!hasCustomSet)
                            loadedMatch = loadedMatch || FindFirst(me.lastLookupData, item => item[getTargetField()] == toSet);
                        else {
                            forceValueSet = !loadedMatch;
                        }
                    }
                    if (forceValueSet) {
                        currApply = toSet;
                        return prop.SetValue(toSet).then(resetCurr, resetCurr);
                    } else {
                        if (!loadedMatch && !!toSet) {
                            var currStarted: PromiseLike<any>;
                            return UISafe(currStarted = lastStarted = me.findSingleMatch(toSet).then(matchItem => {
                                if (currStarted == lastStarted) {
                                    currApply = toSet;
                                    return pFinally(pFinally(prop.SetLookupFromRow(matchItem, currInfo), applyValueToControl), resetCurr);
                                }
                            }).then(() => { }, err => {
                                if (currStarted == lastStarted) { // supress error if another search already running
                                    if (currInfo && currInfo.AllowAllValues === true)
                                        return prop.SetLookupFromValue(toSet);
                                    throw err;
                                }
                            }).then(applyValueToControl, pErr(applyValueToControl)));
                        } else {
                            currApply = toSet;
                            return pFinally(pFinally(prop.SetLookupFromRow(loadedMatch, currInfo), applyValueToControl), resetCurr);
                        }
                    }
                };
                return currApplyPromise = pFinally(pFinally(this.ensureLookupContext(), contextEnsured), resetCurr);
            };

        var readOnlyChanged = (readonly) => {
            wrapper.addClass("k-state-default");
            button.toggleClass("k-state-disabled", !!readonly);
            button.toggleClass("k-state-default", !readonly);

            // Order readonly/enable settings is important!
            autoComplete.readonly(readonly);
            autoComplete.enable(!readonly);
            if (!readonly) {
                wrapper.toggleClass("k-state-hover", false);
                button.toggleClass("k-state-focused", false);
            }
            wrapper.on("mouseenter.nav mouseleave.nav", (e) => { if (!prop.ReadOnly) { $(e.currentTarget).toggleClass("k-state-hover", e.type === "mouseenter"); } });
            button.on("focusin.nav focusout.nav", (e) => {
                if (!prop.ReadOnly) {
                    button.toggleClass("k-state-focused", e.type === "focusin");
                }
            });
        };
        var invalidChanged = (invalid) => autoComplete.wrapper.add(wrapper).toggleClass(kconstants.cssInvalid, invalid);
        this.bind(kconstants.NavDestroy, prop.OnValueChange(applyValueToControl));
        this.bind(kconstants.NavDestroy, prop.OnInvalidChange(invalidChanged));
        this.bind(kconstants.NavDestroy, prop.OnReadonlyChange(readOnlyChanged));

        // Commit Value on blur
        wrapper.on("blur.nav", () => {
            if (!state.Open) {
                applyControlValue();
            } else if (!state.Selected && autoComplete.value()) {
                applyValueToControl();
            }
        });

        autoComplete.wrapper.width("100%").css("border", "none");
        autoComplete.bind("close", () => {
            if (state.Selected) {
                applyControlValue(state.SelectedItem);
            }
        });

        this.element.append(autoComplete.wrapper, button);
        CreateDropDownOverlay(autoComplete);
        applyValueToControl();
        readOnlyChanged(prop.ReadOnly);
        invalidChanged(prop.Invalid);

        function resolveOptions(element, options: NavLookupOptions) {
            var context = options.AttachedParent && options.AttachedParent.length;
            if (options && options.AttachedParent) {
                var ng = angular.element(options.AttachedParent);
                var scope = ng.scope();
                var injector = ng.injector();
            }

            if (!scope) {
                ng = angular.element($(element));
                scope = ng.scope();
                injector = ng.injector();
            }

            if (!(scope && injector))
                throw new Error("NavLookupControl needs ng context at the moment");

            options.$angular = [scope];
            options.$injector = injector;

            return options;
        }
    }

    destroy() {
        if (this.currentSettings)
            this.currentSettings.Save();
        const autoComplete = this.autoComplete;
        [autoComplete.element, this.button, this.element].forEach(item => item && item.off(".nav"));
        autoComplete.destroy();
        this.trigger(kconstants.NavDestroy);

        super.destroy();
    }

    private startShowLookup(source: JQuery) {
        var me = this;
        // In case of edit in grid controls will not be part of dom anymore afterwards!
        var gridInfo = getGridCellEditContext(me.element);
        const afterOpen = () => {
            if (gridInfo)
                gridInfo.editCell();
            else if (source) {
                source.focus();
            }
        };
        me.openLookupWindow().then(afterOpen, afterOpen);
    }

    private openLookupWindow() {
        var prop = this.options && this.options.NavProperty,
            currentItem = prop && prop.CurrentItem,
            root = currentItem && currentItem.Root,
            service = root && root.Service,
            $c = service && <CompatibilityService>service.$c,
            anchor = root && root.Anchor;

        if (!prop)
            var message = "Keine Eigenschaft gebunden";
        if (prop.ReadOnly)
            var message = "Bearbeitung nicht möglich";
        else if (NavLookupControl._openLookupWindow) {
            var message = "Es wird bereits ein Dialog angezeigt, bitte warten Sie diesen ab bzw. schließen Sie diesen Dialog!";
        } else if (anchor.InOperation) {
            var message = "Bitte warten Sie die aktuell laufende Operation ab";
        }
        if (message) {
            return $c.reject(message);
        }
        /** OpenWindow Operation : Allow Visual Notification of opening Operation */
        var openOperation = $c.defer();
        anchor.EnqueueOperation(() => openOperation.promise);
        try {
            const finalAction = () => {
                delete NavLookupControl._openLookupWindow;
                openOperation.resolve();
            };
            return NavLookupControl._openLookupWindow = currentItem.ResolveLookupInfo(prop.Property).then(lookupData => {
                var lookupInfo = lookupData.LookupInfo;
                return service.GetPageClientInfo(lookupInfo.TargetPageName, root.ClientInfo).then(pageClientInfo => {
                    openOperation.resolve();
                    return ShowModalReadMultipleSelect({
                        TargetPage: pageClientInfo,
                        Constraints: lookupInfo.Constraints,
                        InitialDisplayFields: lookupInfo.DisplayFields && lookupInfo.DisplayFields.map(item => item.Name),
                        InitialSearchFields: lookupInfo.DefaultSearchInputFields,
                        Title: lookupInfo.Title || ("Suche nach '" + prop.Property.Title + "'"),
                        PersistToken: (lookupInfo.Name || "_") + "_" + lookupInfo.TargetPageName + "_" + lookupInfo.TargetField,
                    }, $c).then(item => {
                        if (item)
                            return prop.SetLookupFromRow(item, lookupInfo);
                        else
                            return $c.when(undefined);
                    });
                });
            }).then(finalAction, finalAction);
        } catch (err) {
            openOperation.reject(err);
            throw err;
        }
    }
    static _openLookupWindow: any;

    private _initButton() {
        var me = this,
            prop = this.options && this.options.NavProperty,
            button = $('<span title="Detailsuche" class= "k-select" role="button"  >' +
                ' <span class="k-icon k-i-search" ></span>' +
                ' </span>').
                on("focusin.nav", () => me.inButton = true).
                on("focusout.nav", () => me.inButton = false).
                on("click.nav", (e) => {
                    if (!prop.ReadOnly) {
                        const autoComplete = this.autoComplete;
                        // Reset pending, not 'clearing' changes on Opening DrillDown
                        if (autoComplete.value() !== "")
                            autoComplete.value(prop.GetValue(true));

                        UISafe(me.openLookupWindow());
                    }
                }).
                on("keydown.nav", (e) => {
                    if (e.which == kendo.keys.ENTER && !prop.ReadOnly) {
                        me.startShowLookup(button);
                        e.preventDefault();
                    }
                });

        return button;
    }

    private _initAutoComplete() {
        var me = this,
            prop = this.options && this.options.NavProperty,
            maxLen = prop && prop.Property.MaxLength,
            state = me.autoCompleteState;

        var autoComplete = new kendo.ui.AutoComplete($("<input></input>")[0], me.createAutoCompleteOptions(prop));
        /** Force Search event if no minlength ...*/
        function supressMinLength(operation: Function) {
            var options = autoComplete.options,
                l = options.minLength;
            options.minLength = 0;
            try {

                operation();
            } finally {
                autoComplete.options.minLength = l;
            }
        }
        autoComplete.list.width("auto");
        autoComplete.bind("open", () => {
            state.Open = true;
            state.Selected = false;
            delete state.SelectedItem;
            me.trigger("open");
            me.element.trigger("InfDropDownOpen");
        });
        autoComplete.bind("close", () => {
            state.Open = false;
            me.element.trigger("InfDropDownClose");
        });
        autoComplete.bind("select", (e: kendo.ui.AutoCompleteSelectEvent) => {
            var hModel = me.headerModel,
                selItem = state.SelectedItem = autoComplete.dataItem(e.item.index());

            if (selItem && me.headerModel.TargetField) {
                var match = selItem[hModel.TargetField];
                if (match) {
                    var mIds = hModel.History;
                    fn.RemoveIf(mIds, m => m == match);
                    mIds.splice(0, 0, match);
                    mIds.splice(5);
                    me.trigger("HistoryChanged");
                }
            }
            state.Selected = true;
        });

        // Show Lookup on Enter
        autoComplete.element.on("keydown.nav", (e) => {
            if (!prop || prop.ReadOnly)
                return;
            switch (e.which) {
                case kendo.keys.TAB:
                    if (!prop.GetValue(true) && !autoComplete.value() && me.button) {
                        me.button.focus();

                        // Problem (FF) only discard propagation if focusing worked (otherwise : TABBING breaks)
                        if (!window.document.activeElement || (window.document.activeElement === me.button[0])) {
                            e.preventDefault();
                            e.stopImmediatePropagation();
                            e.stopPropagation();
                        }
                    }
                    break;

                case kendo.keys.ENTER:
                    var currInput = autoComplete.value(),
                        currVal = prop.GetValue(true);

                    // Open  Quicklookup if empty of value is unchanged
                    if ((!currInput) || (currInput === currVal)) {
                        if (!this.IsOpen()) {
                            supressMinLength(() => autoComplete.search(currInput));
                            e.preventDefault();
                            e.stopPropagation();
                        }
                    }
                    break;
                default:
                // Nothing to do
            }
        }).on("blur", async () => {
            if (!me.inButton) {
                // me.element.blur(); Not working in FF ..
                // Ensure ui value gets propagated
                const currUiVal: string = autoComplete.element.val() || "";
                if (prop.GetValue(false) !== currUiVal) {
                    const gridInfo = getGridCellEditContext(me.element);
                    try {
                        await me.applyControlValue();
                    } catch (err) {
                        if (gridInfo) {
                            gridInfo.editCell();
                        } else {
                            autoComplete.value(prop.GetValue());
                            autoComplete.focus();
                        }
                        throw err;
                    }
                }
            }
        }).on("focusin.nav", () => {
            state.Focus = true;
            // Set Compatiblity to previous behaviour if MinSearch == 0
            if (me.options.MinSearch == 0 && !state.Open && !prop.CurrentItem.Root.Anchor.InOperation)
                autoComplete.search(autoComplete.value());
        }).on("focusout.nav", () => state.Focus = false);

        if (maxLen > 0)
            autoComplete.element.attr("maxLength", maxLen);

        return autoComplete;
    }

    private currentLookupInfo: { LookupInfo: ILookupInfo; TargetPageInfo: INavPageClientInfo };
    private lastLookupData: any[];
    private currentSettings: InfUserSettingsAccess;

    private resolveSearchValue(value: string, prop: IPageProperty) {
        if (this.currentLookupInfo && this.currentLookupInfo.TargetPageInfo && this.currentLookupInfo.TargetPageInfo.CustomSource) {
            return value;
        }
        switch (prop && prop.Type) {
            case "DateTime":
            case "Int32":
            case "Decimal":
                return value;
            case "String":
            default:
                if (!value || value[0] == "=")
                    return value;

                if (value.indexOf("*") < 0)
                    value = "*" + value + "*";

                if (value.indexOf("@") < 0)
                    value = "@" + value;

                return value;
        }
    }

    /** find Single item matching by given Value (opt. with alternate SearchField) */
    private findSingleMatch(findValue: any) {
        return this.ensureLookupContext().then(() => {
            let currentLookupInfo = this.currentLookupInfo,
                lookup = currentLookupInfo && currentLookupInfo.LookupInfo,
                page = currentLookupInfo && currentLookupInfo.TargetPageInfo,
                currProp = this.options.NavProperty,
                NavClient = currProp.CurrentItem.Root.Service;
            if (!lookup || !page)
                return NavClient.$c.reject("Lookup not Determined");

            findValue = NavClient.PrepareServerValue(currProp.CurrentItem, currProp.Property, findValue);
            var matchConstraint = { FieldName: lookup.TargetField, Value: this.resolveSearchValue(findValue, page.MetaData.PropsByName[lookup.TargetField]) };

            /** Try alternate Search by TargetField (if different from searchfield and no results there) */
            var tryAlternateSearch = this.headerModel.SearchField != lookup.TargetField;
            var navUrl = currentLookupInfo.TargetPageInfo.Url;
            var constraints = <IPageQueryConstraint[]>[];
            constraints.push(matchConstraint, ...lookup.Constraints || []);
            return NavClient.ReadMultiple({ PageName: lookup.TargetPageName, PageCount: 2, Constraints: constraints }, navUrl).then(data => {
                var currTry = NavClient.$c.when(data);
                if (data.Data.length > 1 && /^[a-z0-9]+$/i.test(("" + findValue))) {
                    currTry = currTry.then(() => {
                        matchConstraint.Value = "=" + findValue;
                        return NavClient.ReadMultiple({ PageName: lookup.TargetPageName, PageCount: 2, Constraints: constraints }, navUrl);
                    });
                }
                if (data.Data.length != 1 && tryAlternateSearch) {
                    currTry = currTry.then(data => {
                        if (data.Data.length == 1)
                            return data;
                        var field = matchConstraint.FieldName = this.headerModel.SearchField;
                        // TODO Only if SearchField not Int
                        matchConstraint.Value = this.resolveSearchValue(findValue, page.AllProperties[field]);

                        return NavClient.ReadMultiple({
                            PageName: lookup.TargetPageName, PageCount: 2,
                            BookmarkData: undefined, Constraints: constraints
                        }, navUrl);
                    });
                }
                return currTry;
            }).then(data => {
                var rData = data.Data,
                    rCount = data.Data.length;
                if (rCount == 1)
                    return rData[0];
                if (rCount > 1)
                    throw new Error(`'${findValue}' liefert kein eindeutiges Ergebnis!`);
                throw new Error(`'${findValue}' ist kein gültiger Wert!`);
            });
        });
    }

    /** create Options for the AutoComplete Control */
    private createAutoCompleteOptions(navPropValue: NavPropertyValue): kendo.ui.AutoCompleteOptions {
        var me = this,
            $injector = me.options.$injector,
            UserSettings = $injector && $injector.get<NavSettingsService>("NavSettings"),
            state = me.autoCompleteState,
            headerModel = me.headerModel,
            headerRoot = $(
                `<table class='navLookupTable' ng-style='{ width : Head.Width + "px" }'>
    <tbody>
        <tr ng-show='Head.InfoText' style="min-height: 17px">
            <td class='navLookupResults' colspan='{{Head.Fields.length}}'>
                {{Head.InfoText}}
            </td>
        </tr>
        <tr class='navLookupHeader' style='min-height: 21px'>
            <th class='navLookupHeaderCell' ng-class='{ "k-state-selected" : (field.name == Head.MatchField), "idms_filtered" : (field.current && !Head.CurrHistory) }' ng-repeat='field in Head.Fields track by field.id ' ng-click='Head.SetSearchField(field.name)'>
                <span ng-class='{ "k-link" : !field.current }' style='display: inline-block; width:100%' title='{{ !field.current ? field.caption + " als Suchfeld wählen" : "Gewähltes Suchfeld: " + field.caption}}'>
                    <span class='idms_Icon idms_Icon_Filter' ng-show='field.current && !Head.CurrHistory'></span>
                    <span>{{field.caption}}</span>
                </span>
            </th>
        </tr>
        <tr style="height: 5px"><td></td></tr>
    </tbody>
</table>`);

        headerModel["SetSearchField"] = this.setSearchField.bind(this);
        /**  "History" Functionality Disabled until further discussion */
        var actToggleHist = headerModel["ToggleHistory"] = {
            Refresh: () => {
                actToggleHist.Enabled = false; // !headerModel.SearchValue && headerModel.History.length > 0;
                actToggleHist.Caption = headerModel.UserNoHistory ? "->Zuletzt verwendet" : "->Alle";
            },
            Enabled: false,
            Hidden: "Enabled",
            Caption: "???",
            Execute: () => {
                headerModel.UserNoHistory = !headerModel.UserNoHistory;
                var value = me.autoComplete.value();
                me.autoComplete.search(value);
                actToggleHist.Refresh();
            },
        };
        me.bind("HistoryChanged", actToggleHist.Refresh);
        actToggleHist.Refresh();

        var setCountInfo = (text: string) => headerModel.InfoText = text;
        var defaultMaxRead = this.options.MaxRead || 10;
        var dataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: <any><kendo.data.DataSourceTransportWithFunctionOperations>{
                read: (readParams) => {
                    // Problem is readParams.error will not cancel UI Progress !!, so finish with success (!?!)
                    var handleError = (err: any) => {
                        var errInfo = resolveToError(err);
                        setCountInfo(errInfo);
                        readParams.success([]);
                    };
                    ensureLookupContext().then((lookupInfo) => {
                        var currentLookup = lookupInfo.LookupInfo,
                            propMax = me.options.NavProperty.Property.MaxRead,
                            maxRead = propMax || defaultMaxRead,
                            rFilter = readParams.data.filter,
                            rFilters = (<kendo.data.DataSourceFilterItem[]>(rFilter && rFilter.filters || []))
                                .sort(item => item.field == "_dummy" ? 0 : 1), // fix precedence --> still necessary after kendo upgrade >= 2018.1
                            readFilters = rFilters.map(item => {
                                return <IPageQueryConstraint>{
                                    FieldName: item.field == "_dummy" ? currentLookup.TargetField : item.field,
                                    Value: item.field == "_dummy" || item.field == currentLookup.TargetField ? navPropValue.CurrentItem.Root.Service.PrepareServerValue(navPropValue.CurrentItem, navPropValue.Property, item.value) : item.value
                                };
                            }),
                            check = ToDictionary(readFilters, f => f.FieldName);

                        // Prepare Filter Values
                        readFilters = Object.getOwnPropertyNames(check).map(f => check[f]);

                        var constraints = <IPageQueryConstraint[]>[];
                        var navUrl = me.currentLookupInfo.TargetPageInfo.Url;
                        constraints.push(...currentLookup.Constraints || []);

                        var currModelValue = ("" + navPropValue.GetValue(true, true)).toLowerCase();
                        /** Try alternate Search by TargetField (if different from searchfield and no results there) */
                        var tryAlternateSearch = headerModel.SearchField != currentLookup.TargetField;
                        var checkFilters = readFilters.map(f => {
                            var result = {
                                // remember "original" Value
                                Value: f.Value,
                                FieldName: f.FieldName,
                                IsCurrValue: currModelValue && currModelValue === f.Value
                            };
                            if (result.IsCurrValue) {
                                f.Op = "eq";
                                tryAlternateSearch = false; // no alternate Search if "full match" is searched
                            } else {
                                // AutoComplete Does not have a "different serarch field, so remap!"
                                result.FieldName = f.FieldName = headerModel.SearchField;
                            }

                            var prop = lookupInfo.TargetPageInfo.MetaData.PropsByName[f.FieldName];
                            if ((!this.NavIsInt) && !result.IsCurrValue) {
                                f.Value = me.resolveSearchValue(f.Value, prop);
                            }
                            return result;
                        }, this);

                        var userFilter = checkFilters[0];
                        headerModel.SearchValue = (userFilter && userFilter.Value) || "";
                        headerModel.CurrHistory = !headerModel.UserNoHistory && !headerModel.SearchValue && headerModel.History.length > 0;

                        if (headerModel.CurrHistory) {
                            constraints.push({ FieldName: me.headerModel.TargetField, Value: "'" + headerModel.History.join("' | '") + "'" });
                            setCountInfo("zuletzt verwendet:");
                        } else {
                            constraints.push(...readFilters);
                            setCountInfo("...");
                        }
                        let NavClient = this.options.NavProperty.CurrentItem.Root.Service;
                        UISafe(NavClient.ReadMultiple({ PageName: currentLookup.TargetPageName, PageCount: maxRead, Constraints: constraints }, navUrl)
                            .then(data => {
                                var sTry = NavClient.$c.when(data);
                                if (data.Data.length == 0 && tryAlternateSearch) {
                                    readFilters.forEach(c => { if (c.FieldName == headerModel.SearchField) userFilter.FieldName = c.FieldName = currentLookup.TargetField; });
                                    sTry = NavClient.ReadMultiple({
                                        PageName: currentLookup.TargetPageName, PageCount: maxRead, Constraints: constraints
                                    }, navUrl);
                                    // to only use single Match for key alternate search on keyfield :
                                    //.then(d => { if (d.Data.length !== 1 || d.Data[0][userFilter.FieldName] != userFilter.Value) { d.Data.length = 0 } return d; });

                                }
                                sTry.then(data => {
                                    if (!state.Open && !state.Focus) {
                                        readParams.success([]);
                                        setCountInfo("Cancelled");
                                    }
                                    else {
                                        var foundItems = data.Data;
                                        readParams.success(me.lastLookupData = foundItems);

                                        if (headerModel.CurrHistory) {
                                            headerModel.MatchField = "";
                                        } else {

                                            //  MatchField : only if search against non empty user Input
                                            if (userFilter) {
                                                if (userFilter.Value === "") {
                                                    headerModel.MatchField = "";
                                                } else {
                                                    headerModel.MatchField = userFilter.FieldName;
                                                }
                                            }

                                            if (!data.Bookmark.AllRead)
                                                setCountInfo(">" + maxRead + " Ergebnisse");
                                            else {
                                                setCountInfo(foundItems.length == 1 ? "" : foundItems.length + " Ergebnisse");
                                            }
                                        }
                                    }
                                }, handleError);
                            }, handleError).then(undefined, handleError));
                    }).then(undefined, handleError).then(actToggleHist.Refresh, actToggleHist.Refresh);
                }
            }
        });

        me.one("open", () => {
            // TODO : "cleanup" necessary?
            me["angular"]("compile", () => { return { elements: headerRoot, data: [{ Head: headerModel }] }; });
            // WTF : IN Chrome size of dropDown gets initially set "wrong" : re force calculation
            window.setTimeout(() => {
                var _calculatePopupHeight = me.autoComplete && me.autoComplete["_calculatePopupHeight"];
                if (typeof _calculatePopupHeight == "function")
                    _calculatePopupHeight.call(me.autoComplete, true);
            }, 0);
        });

        var currentRowtemplate: (data: any) => string = fn.noop;
        var result = <kendo.ui.AutoCompleteOptions>{
            //animation: false,
            dataSource: dataSource,
            dataTextField: "_dummy", // we might not now the dest field name initially
            highlightFirst: false,
            suggest: false,
            minLength: this.options.MinSearch >= 0 ? this.options.MinSearch : 0,
            headerTemplate: (t) => headerRoot,
            template: t => currentRowtemplate(t),
            clearButton: false
        };

        me.ensureLookupContext = ensureLookupContext;
        return result;

        /** Refresh Header/Row Templates after Underlying LookupInfo Changed */
        function refreshTemplates() {
            var lookupInfo = me.currentLookupInfo,
                pageData = lookupInfo && lookupInfo.TargetPageInfo.MetaData,
                lookup = lookupInfo && lookupInfo.LookupInfo,
                fields = lookup && pageData && lookup.DropDownFields.filter(item => pageData.PropsByName[item.Name]) || [],
                isScrollbar = true, // Row template has 5px extra margin on each side + dyn. 10px scrollbar
                fixedWith = fields.length * 175,
                dynWidth = headerModel.Width = (isScrollbar ? 20 : 10) + fixedWith;

            headerModel.SearchField = lookup.SearchField || lookup.TargetField;
            headerModel.TargetField = lookup.TargetField;
            headerModel.History.length = 0;
            headerModel.Fields = fields.map(item => {
                var prop = pageData.PropsByName[item.Name];
                return {
                    id: kendo.guid(),
                    caption: (item.Title || (prop && prop.Title) || "?"),
                    name: item.Name,
                    current: item.Name == headerModel.SearchField,
                    target: item.Name == lookup.TargetField
                };
            });

            // Refresh Current  Row Template
            var strRowTemplate = '<table class="navLookupTable" style="width: ' + fixedWith + 'px;"><tr>';
            const service = navPropValue.CurrentItem && navPropValue.CurrentItem.Root.Service;
            fields.forEach(item => {
                var p = pageData.PropsByName[item.Name];
                var template = p ? kendoGetDisplayTemplate(p, "data") : '#: data["' + item.Name + '"] #';
                // right align Currency Fields (TODO : idms_CurrencyField, doesn't work here!)
                if (p.Type === 'Decimal' && p.DecimalNumericType === NumericType.Currency)
                    var customStyle = ' style="text-align: right" ';

                if (service)
                    template = service.PrepareDDColumn(pageData, p, "data", template);
                strRowTemplate += `<td class="navLookupItemCell"${customStyle || ''}>${template}</td>`;
            });
            strRowTemplate += "</tr></tbody></table>";
            currentRowtemplate = ktemplate(strRowTemplate);
        }

        var settingsKey: string;
        /** ensure Current Lookup Context is Loaded and props are properly set */
        function ensureLookupContext() {
            return navPropValue.CurrentItem.ResolveLookupInfo(navPropValue.Property).then(lookupInfo => {
                var currentLookup = lookupInfo.LookupInfo;
                if (me.currentLookupInfo !== lookupInfo) {
                    me.currentLookupInfo = lookupInfo;
                    me.lastLookupData = undefined;
                    if (result.dataTextField != currentLookup.TargetField) {
                        result.dataTextField = me.autoComplete.options.dataTextField = currentLookup.TargetField;
                        me.autoComplete.setOptions(result);
                        const currFilter = dataSource.filter();
                        const cFilters = currFilter && currFilter.filters && currFilter.filters.length && currFilter.filters;
                        if (cFilters) {
                            // 'Fix' to Correct name ...
                            const getFilter = (name: string) => cFilters.filter((item: kendo.data.DataSourceFilterItem) =>
                                item.field == name)[0] as kendo.data.DataSourceFilterItem;
                            const checkDummy = getFilter("_dummy");
                            if (checkDummy) {
                                var exDummy = cFilters.indexOf(getFilter(currentLookup.TargetField));
                                if (exDummy >= 0) {
                                    cFilters.splice(exDummy, 1);
                                }
                                checkDummy.field = currentLookup.TargetField;
                            }
                        }
                    }
                    var newSettingsKey = (currentLookup.Name || "_") + "_" + currentLookup.TargetPageName + "_" + currentLookup.TargetField;
                    if (newSettingsKey != settingsKey) {
                        refreshTemplates();
                        settingsKey = newSettingsKey;
                        if (me.currentSettings)
                            me.currentSettings.Save();
                        var settings = me.currentSettings = UserSettings.CreateUserSettings(["KWF", "Lookup", "LookupDD_" + settingsKey]);
                        settings.Add("SearchModel", () => {
                            return {
                                SearchField: me.headerModel.SearchField,
                                UserNoHistory: me.headerModel.UserNoHistory,
                                History: me.headerModel.History.map(fn.identity)
                            };
                        }, state => {
                            if (state.SearchField)
                                me.setSearchField(state.SearchField);
                            if (typeof (state.UserNoHistory) == "boolean") {
                                me.headerModel.UserNoHistory = state.UserNoHistory;
                            }
                            if ($.isArray(state.History))
                                me.headerModel.History = state.History.map(fn.identity);

                            me.trigger("HistoryChanged");
                        });
                        return settings.Load().then(fn.noop, fn.noop).then(() => lookupInfo);
                    }
                }

                return lookupInfo;
            });
        }
    }

    /** promise to ensure current lookup Context is set (gets initialized with autoComplete initialization) */
    private ensureLookupContext: () => PromiseLike<any>;

    /** Change Current search Field */
    private setSearchField(name: string) {
        var head = this.headerModel,
            fields = this.headerModel.Fields,
            curr = fn.FindFirst(fields, "name", name);
        if (!curr || !curr.current) {
            fields.forEach(item => item.current = item == curr);
            head.SearchField = (curr && curr.name) || head.TargetField;
            this.resetMatchFieldOnEmpty();
            // Trigger Search if input is not empty
            var currVal = this.autoComplete.value();
            if (currVal)
                this.autoComplete.search(currVal);
        }
    }

    /** Reset MatchField if no more data is displayed (matched) */
    private resetMatchFieldOnEmpty() {
        var showsLines = this.lastLookupData && this.lastLookupData.length > 0;
        if (!showsLines) {
            this.headerModel.MatchField = "";
        }
    }
}
NavKendoRegister(NavLookupControl, "NavLookupControl", {});

// In case of edit in grid controls will not be part of dom anymore afterwards!
  function getGridCellEditContext(element: JQuery) {
    var cell = element.closest("td[role = gridcell]"),
      kGrid = cell.parents().addBack().filter(function () {
        return $(this).data("kendoGrid") !== undefined;
      }).first().data("kendoGrid");

    return kGrid && {
      editCell: () => { kGrid.editCell(cell); }
    };
  }


/** get String for a template in kendo Style from given Page Property */
export function kendoGetDisplayTemplate(p: IPageProperty, argumentName: string) {
    var pName = argumentName ? argumentName + '["' + p.Name + '"]' : p.Name;
    switch (p.Type) {
        case "Boolean":
            return "#: " + pName + " ? 'Ja' : 'Nein' #";

        case "Decimal":
            var format = kutils.NumericFormat[p.DecimalNumericType];
            if (format) {
                return "#: " + pName + ' !== undefined ? kendo.format("' + format + '", ' + pName + ') : "" #';
            }
            break;

        case "DateTime":
            var format = kutils.DateFormat[p.DateFormat || 0];
            return "#: " + pName + ' ? kendo.format("' + format + '", ' + pName + ') : "" #';

        default:
            if (p.EnumMappings) {
                var result = "#var v =" + kendo.stringify(fn.ToDictionaryEx(p.EnumMappings, e => e.Value.toString(), e => e.Title)).replace(/#/ig, "\\#") + "#";
                result += "#var f = v[" + pName + "]#";
                result += "${f !== undefined ? f : " + pName + "}";
                return result;
            }

    }
    return "#: " + pName + ' !== undefined ? ' + pName + ' : "" #';
}

declare global {
    interface JQuery {
        /** NavDockZones Extension for NavpPageItem Display */
        kendoNavLookupControl(options: NavLookupOptions);
        data(key: "kendoNavLookupControl"): NavLookupControl;
    }
}
